import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { get } from '../../../api/fetch';
import { userDataSessionStorageKey } from '../utils/utils';
import { UserResponse } from '../types/UserResponse';

const defaultUserResponse: UserResponse = {
  isAuthorized: false,
  fullname: ''
};

export const getUserStateFromStorage = (): UserResponse | null => {
  try {
    const sessionUser = sessionStorage.getItem(userDataSessionStorageKey);
    if (sessionUser) {
      return JSON.parse(sessionUser);
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const useUserState = (): UseQueryResult<UserResponse> => {
  const defaultUser = getUserStateFromStorage() ?? defaultUserResponse;

  return useQuery({
    queryKey: [userDataSessionStorageKey],
    queryFn: async () => get('/api/user'),
    select: (response: UserResponse) => response ?? defaultUser,
    enabled: !defaultUser.isAuthorized,
    initialData: defaultUser
  });
};
